module.exports = __webpack_public_path__ + "img/playson.318d3e76.svg";